import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { Navbar, Nav, Button } from "react-bootstrap";

const CustomNavbar = () => {
    const { user, logout } = useContext(AuthContext);

    return (
        <Navbar style={{ background: "rgb(42, 113, 155)" }} variant="dark" expand="lg">
            <div className="container">
                <Navbar.Brand as={Link} to="/" className="brand-logo">
                    Sri Sai Tech
                </Navbar.Brand>

                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto">
                        {/* <Nav.Link as={Link} to="/">Home</Nav.Link> */}
                        {/* <Nav.Link as={Link} to="/about">About</Nav.Link> */}
                        <Nav.Link as={Link} to="/order_log">Orderlog</Nav.Link>
                        {user ?
                            user.is_admin ? (
                                <>
                                    {/* <Nav.Link as={Link} to="/admin_access">newbilltype</Nav.Link> */}
                                    <Nav.Link as={Link} to="/categories">Categories</Nav.Link>
                                    <Nav.Link as={Link} to="/customer_data">Customer</Nav.Link>
                                    <Nav.Link as={Link} to="/user">Users</Nav.Link>
                                    <Button variant="danger" onClick={logout}>Logout</Button>
                                </>
                            ) :
                                (
                                    <Button variant="danger" onClick={logout}>Logout</Button>
                                )
                            : (
                                <Nav.Link as={Link} to="/login">Login</Nav.Link>
                            )}
                    </Nav>
                </Navbar.Collapse>
            </div>
        </Navbar>
    );
};

export default CustomNavbar;
